import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import { AMOUNT_LOCALE } from '../i18n';

const PYG_SYMBOL = 'PY₲';

//
// Bracket boundaries as shown to the user. These mirror calculateByTaxBracket()
// in IRPCalculator.js -- change both together.
// Source: Ley 6380/2019 + DNIT cartilla IRP; verified current on 2026-08-15.
//
const BRACKETS = [
  { from: 0, to: 50000000, percentage: 8 },
  { from: 50000001, to: 150000000, percentage: 9 },
  { from: 150000001, percentage: 10 },
];

export default function IRPTable() {
    const { t } = useTranslation();
    const formatter = Intl.NumberFormat(AMOUNT_LOCALE);

    const rangeLabel = ({ from, to }) =>
      to === undefined
        ? t('table.rangeAbove', { from: formatter.format(from) })
        : t('table.rangeBetween', { from: formatter.format(from), to: formatter.format(to) });

    return (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell><strong>{t('table.netIncome', { currency: PYG_SYMBOL })} </strong></TableCell>
                <TableCell align="right"><strong>{t('table.appliedPercent')}</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {BRACKETS.map((row) => (
                <TableRow
                  key={row.percentage}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {rangeLabel(row)}
                  </TableCell>
                  <TableCell align="right">{`${row.percentage}%`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
}
